var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 24C1.46667 24 1 23.8 0.6 23.4C0.2 23 0 22.5333 0 22V2C0 1.46667 0.2 1 0.6 0.6C1 0.2 1.46667 0 2 0H17.4L24 6.6V22C24 22.5333 23.8 23 23.4 23.4C23 23.8 22.5333 24 22 24H2ZM2 22H22V7.7H16.3V2H2V22ZM5.3 18.3H18.7V16.3H5.3V18.3ZM5.3 7.7H12V5.7H5.3V7.7ZM5.3 13H18.7V11H5.3V13Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalism);
export default __webpack_public_path__ + "static/media/journalism.48f6d2dba51fd947113a1aef3d4af0a2.svg";
export { ForwardRef as ReactComponent };